import { render, staticRenderFns } from "./stair.vue?vue&type=template&id=b105fd60"
import script from "./stair.vue?vue&type=script&lang=js"
export * from "./stair.vue?vue&type=script&lang=js"
import style0 from "./stair.vue?vue&type=style&index=0&id=b105fd60&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports